import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../../lib/site";

const FinalCTA = ({ heading = "Ready for a Floor Built to Last a Lifetime?" }) => (
  <section className="py-20 md:py-24 bg-zinc-950 border-t border-zinc-900" data-testid="final-cta">
    <div className="max-w-4xl mx-auto px-5 lg:px-12 text-center">
      <span className="text-[#C69453] text-sm font-semibold tracking-[0.2em] uppercase">Never Cutting Corners</span>
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-white mt-3 leading-tight">{heading}</h2>
      <p className="text-zinc-400 text-base md:text-lg mt-4 max-w-2xl mx-auto">
        Call us directly. No call centers, no pressure — just honest advice from the family who will be on your job.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
        <a href={PHONE_TEL} data-testid="final-cta-call" className="bg-[#C69453] hover:bg-[#AE7F44] text-black font-extrabold text-lg px-8 py-4 transition-colors flex items-center justify-center gap-2">
          <Phone className="w-5 h-5" />
          <span>Call Pryme: {PHONE_DISPLAY}</span>
        </a>
        <Link to="/contact" data-testid="final-cta-estimate" data-track="cta_estimate" data-track-label="final-cta" className="border border-[#C69453] text-[#C69453] hover:bg-[#C69453]/10 font-bold text-lg px-8 py-4 transition-all flex items-center justify-center gap-2">
          <span>Request Free Estimate</span>
          <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </div>
  </section>
);

export default FinalCTA;
